module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel cc-panel-default"
  }, [(!this.memo.id) ? [_c('div', {
    staticClass: "media-body media-right text-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idUser == 0),
      expression: "idUser == 0"
    }],
    staticClass: "btn btn-link",
    attrs: {
      "title": "Neuer Eintrag",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editModus = 'dienst'
      }
    }
  }, [_c('span', [_vm._v("Neuer Dienst")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "btn btn-link",
    attrs: {
      "title": "Neuer Eintrag",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editModus = 'absence'
      }
    }
  }, [_c('span', [_vm._v("Neue Abwesenheit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "title": "Neuer Eintrag",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editModus = 'edit'
      }
    }
  }, [_c('span', [_vm._v("Neue Vorgabe")])])])] : [_c('div', {
    staticClass: "panel-heading media",
    attrs: {
      "role": "tab",
      "id": _vm.headingID
    }
  }, [_c('p', {
    staticClass: "panel-title media-body media-middle"
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "width": "100%",
      "padding": "6px 0px 6px 0px"
    },
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": '#' + _vm.data_parent,
      "href": '#' + _vm.collapsID,
      "aria-expanded": "true",
      "aria-controls": _vm.collapsID
    }
  }, [_c('i', {
    staticClass: "fa  fa-lg",
    class: _vm.MemoConf.TYP[_vm.memo.typ].SYMBOL.CLASS,
    attrs: {
      "title": _vm.MemoConf.TYP[_vm.memo.typ].SYMBOL.TITLE,
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.headline))]), _vm._v(" - "), _c('small', [_vm._v(" " + _vm._s(_vm.memo.summary))])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right text-right media-middle",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": '#' + _vm.data_parent,
      "href": '#' + _vm.collapsID,
      "aria-expanded": "true",
      "aria-controls": _vm.collapsID
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memo.text),
      expression: "memo.text"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCollapseIn == false),
      expression: "isCollapseIn == false"
    }],
    staticClass: "fa fa-expand",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCollapseIn == true),
      expression: "isCollapseIn == true"
    }],
    staticClass: "fa fa-compress ",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-link cc-btn-menue",
    attrs: {
      "type": "button",
      "title": "Eintrag bearbeiten"
    },
    on: {
      "click": function($event) {
        _vm.editModus = 'edit'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-vertical"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      in: _vm.collapseIn
    },
    attrs: {
      "id": _vm.collapsID,
      "role": "tabpanel",
      "aria-labelledby": _vm.headingID
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._l((_vm.memo.userClientRef), function(userClient) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.onHitUserClient(userClient.id)
        }
      }
    }, [_vm._v("\n             " + _vm._s(userClient.firstName) + " " + _vm._s(userClient.lastName) + " " + _vm._s(userClient.department) + " " + _vm._s(userClient.room) + " " + _vm._s(userClient.function) + "\n           ")])])
  }), _vm._v(" "), _vm._l((_vm.memo.textSplited), function(text, index) {
    return _c('span', {
      style: (text.style)
    }, [(text.idUserClient > 0) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.onHitUserClient(text.idUserClient)
        }
      }
    }, [_vm._v("\n             " + _vm._s(text.text) + "\n           ")]) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(text.text)
      }
    })])
  })], 2)])], _vm._v(" "), (_vm.editModus == 'dienst') ? _c('cc-memo-dienst-modal', {
    attrs: {
      "memo": _vm.memo,
      "idCompany": _vm.idCompany,
      "idUser": _vm.idUser
    },
    on: {
      "cancel": _vm.cancel,
      "remove": _vm.remove,
      "save": _vm.save
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editModus == 'absence') ? _c('cc-memo-absence-modal', {
    attrs: {
      "memo": _vm.memo,
      "idCompany": _vm.idCompany,
      "idUser": _vm.idUser
    },
    on: {
      "cancel": _vm.cancel,
      "remove": _vm.remove,
      "save": _vm.save
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editModus == 'edit') ? _c('cc-memo-modal', {
    attrs: {
      "memo": _vm.memo,
      "idCompany": _vm.idCompany,
      "idUser": _vm.idUser
    },
    on: {
      "cancel": _vm.cancel,
      "remove": _vm.remove,
      "save": _vm.save
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e441a1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Memo.vue
// module id = 261
// module chunks = 0